import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../authContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from '@fortawesome/free-brands-svg-icons'

// import { FirebaseApp } from "../index";
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import "./login.css";
import MessageContainer from "../messageContainer/MessageContainer";
import { accountExists, invalidCredential, logoutSuccess } from "../data/data";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showpopup, setshowpopup] = useState(false);
  const [logoutSuccessPopup, setLogoutSuccessPopup] = useState(false);
  const[showAccExistsPopup,setShowAccExistsPopup] = useState(false);

  // const auth = getAuth(FirebaseApp);

  const { isLogout,ifAccExists ,loginByOAuthGoogle,invalidCredentials, login } = useAuthContext();

  const redirect = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    login(email, password);
  };

  function handleGoogleLogin() {
    loginByOAuthGoogle();
  }

  useEffect(()=>{
    if(ifAccExists)setShowAccExistsPopup(true)
    else setShowAccExistsPopup(false);
  },[ifAccExists]);

  useEffect(()=>{
    const timeoutIdAccExists = setTimeout(()=>{
      setShowAccExistsPopup(false);
    },5000)

    return () => clearTimeout(timeoutIdAccExists);
  },[showAccExistsPopup])


  useEffect(() => {
    if (isLogout) {setLogoutSuccessPopup(true);}
    else setLogoutSuccessPopup(false);
  }, [isLogout]);

  useEffect(() => {
    const timeoutIdLogoutSuccess = setTimeout(() => {
      setLogoutSuccessPopup(false);
    }, 3000);
    return () => clearTimeout(timeoutIdLogoutSuccess);
  }, [logoutSuccessPopup]);

  useEffect(() => {
    if (invalidCredentials) {
      setshowpopup(true);
    } else {
      setshowpopup(false);
    }
  }, [invalidCredentials]);

  useEffect(() => {
    const timeoutIDLoginFailed = setTimeout(() => {
      setshowpopup(false);
    }, 5000);

    return () => clearTimeout(timeoutIDLoginFailed);
  }, [showpopup]);

  return (
    <div className="parent-container">
      <div className={"auth-container "}>
        <h1 className="container-title">
          Existing User? <span>Login</span>
        </h1>
        <div className="login-container">
          <p>Enter mail and password to log into account</p>
          <form className="login-form" onSubmit={handleSubmit}>
            <label for="email">
              <span>&nbsp;&nbsp;E-Mail</span>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="Email"
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <label for="password">
              <span>&nbsp;&nbsp;Enter Password</span>
              <input
                type="password"
                id="password"
                name="password"
                // minLength={8}
                placeholder="Password"
                required
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <button type="submit">Log in</button>
          </form>
        </div>
        <div className="redirect-to-signup">
          Don't have an account?{" "}
          <span onClick={() => redirect("/Signup")}>Signup</span>
           &nbsp;or Login using,
        </div>
        <div className="login-oauth-icons">
          <div className="oauth-google-icon" onClick={handleGoogleLogin}>
          <FontAwesomeIcon icon={faGoogle} />
          </div>
        </div>
      </div>
      {showpopup ? <MessageContainer data={invalidCredential} /> : null}
      {logoutSuccessPopup ? <MessageContainer data={logoutSuccess} /> : null}
      {showAccExistsPopup ? <MessageContainer data={accountExists} /> : null}
    </div>
  );
};

export default Login;
